import { gql } from '@apollo/client';

export const RETAIL_SALES_MONTH_TO_DATE = gql`
  query BusinessSalesMonth($filterAll: GlobalFilterInput, $export: Boolean!) {
    all: BusinessSalesMonth(filter: $filterAll, export: $export) {
      count
      businessSalesMonth
      businessSalesMonthRetail
      tenDays
      twentyDays
    }
  }
`;
